'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Spinner = require('../Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _CheckMark = require('./CheckMark');

var _CheckMark2 = _interopRequireDefault(_CheckMark);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function (_Component) {
  (0, _inherits3.default)(Button, _Component);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).call.apply(_ref, [this].concat(args))), _this), _this.getClassNames = function (type) {
      var _this$props = _this.props,
          loading = _this$props.loading,
          success = _this$props.success,
          parentWidth = _this$props.parentWidth;

      var useType = type ? '--' + type : '';
      var classes = {};
      classes['quiver-button' + useType] = true;
      classes['quiver-button--parent-width'] = parentWidth;
      classes['quiver-button--loading'] = loading;
      classes['quiver-button--success'] = success;
      return (0, _classnames2.default)(classes);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Button, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          success = _props.success,
          loading = _props.loading,
          onClick = _props.onClick,
          type = _props.type,
          children = _props.children,
          button = _props.button,
          style = _props.style;


      return _react2.default.createElement(
        'button',
        (0, _extends3.default)({
          className: this.getClassNames(type),
          style: style,
          disabled: loading || success,
          onClick: !loading && onClick
        }, button),
        function () {
          if (loading) {
            return _react2.default.createElement(_Spinner2.default, null);
          }
          if (success) {
            return _react2.default.createElement(_CheckMark2.default, null);
          }
          return children;
        }()
      );
    }
  }]);
  return Button;
}(_react.Component);

Button.propTypes = {
  loading: _propTypes2.default.bool,
  success: _propTypes2.default.bool,
  parentWidth: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  type: _propTypes2.default.string,
  children: _propTypes2.default.node,
  button: _propTypes2.default.object,
  style: _propTypes2.default.object
};
exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Button/Button.js
// module id = 267
// module chunks = 0